import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { makeThunk } from "helpers/makeThunk";
import { handleCommonCases } from "helpers/thunkHandler";
import {
  BROADCAST_NOTIFICATIONS,
  DELETE_NOTIFICATION,
  GET_NOTIFICATION_DETAILS,
  GET_NOTIFICATIONS,
  UPDATE_NOTIFICATION,
} from "helpers/url_helper";

export const sendPushNotification = makeThunk({ url: BROADCAST_NOTIFICATIONS });
export const getNotifications = makeThunk({ url: GET_NOTIFICATIONS });
export const updateNotification = makeThunk({
  url: UPDATE_NOTIFICATION,
  method: "put",
});
export const deleteNotification = makeThunk({
  url: (payload) => `${DELETE_NOTIFICATION}/${payload.id}`,
  type: `${DELETE_NOTIFICATION}_DELETE_NOTIFICATION`,
  method: "delete",
});
export const getNotificationDetails = makeThunk({
  type: `${GET_NOTIFICATION_DETAILS}_GET_DETAILS`,
  url: (id) => `${GET_NOTIFICATION_DETAILS}/${id}`,
  method: "get",
});

const initialState = {
  loading: false,
  isLoading: false,
  totalCount: null,
  totalPages: null,
  currentPage: null,
  filters: {
    perPage: 50,
    pageNo: 1,
    type: ["specific_customers", "all"],
    status: "", //pending ,sent,open
    keyword: "",
    dates: [],
  },
  notifications: [],
  notificationDetails: {},
  isScheduled: true,
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,

  reducers: {
    setFilter: (state, action) => {
      const { key, value } = action.payload;
      state.filters[key] = value;
    },
    setIsScheduled: (state) => {
      state.isScheduled = !state.isScheduled;
    },

    resetFilters: (state) => {
      state.filters = initialState.filters;
    },
  },

  extraReducers: (builder) => {
    handleCommonCases(builder, sendPushNotification, {});
    handleCommonCases(builder, getNotifications, {
      onFulfilled: (state, action) => {
        const { data, totalCount, totalPages, currentPage } =
          action.payload || {};
        state.notifications = data || [];
        state.totalCount = totalCount;
        state.totalPages = totalPages;
        state.currentPage = currentPage;
      },
    });
    handleCommonCases(builder, deleteNotification, {
      loadingKey: "isDeleting",
      onFulfilled: (state, action) => {
        const deletedId = action.meta.arg.id;
        state.notifications = state.notifications.filter(
          (item) => item._id !== deletedId
        );
        if (state.totalCount !== null) {
          state.totalCount = state.totalCount - 1;
        }
      },
    });
    handleCommonCases(builder, getNotificationDetails, {
      onPending: (state) => {
        state.notificationDetails = {};
      },
      onFulfilled: (state, action) => {
        const { data } = action.payload || {};
        state.notificationDetails = data || {};
      },
    });
    handleCommonCases(builder, updateNotification, {
      loadingKey: "isLoading",
    });
  },
});

export const { setFilter, resetFilters, setIsScheduled } =
  notificationSlice.actions;

export default notificationSlice.reducer;
